<template>
  <div class="py-1">
    <ValidationProvider :name="name" :rules="rules" v-slot="{ errors, valid }">
      <transition name="slide-fade">
        <div class="vs-input--label" v-if="innerValue && (innerValue.length || Object.keys(innerValue).length)">
          <span class="hrsys-input-label">{{ inputLabel }}</span>
        </div>
      </transition>
      <div style="height: 17px"></div>
      <vs-textarea
        :danger="rules && !valid && !!errors[0]"
        :danger-text="errors[0]"
        :type="type"
        :disabled="disabled"
        @input="$emit('input', $event)"
        @keydown.native.ctrl.enter="submit"
        :class="[{'bg-gray-100' : disabled}, 'w-full']"
        novalidate
        v-bind="$attrs"
        v-model="innerValue"
      />
    </ValidationProvider>
  </div>
</template>

<script>
  export default {
    props: ['value', 'name', 'label', 'disabled', 'inline', 'box', 'type', 'min', 'rules', 'inputLabel'],
    data: () => ({
      innerValue: ""
    }),
    methods: {
      submit(event) {
        event.target.form.dispatchEvent(new Event("submit", {cancelable: true}));
      }
    },
    watch: {
      value (newVal) {
        this.innerValue = newVal;
      }
    },
    created () {
      if (this.value) {
        this.innerValue = this.value;
      }
    }
  }
</script>

<style scoped>

</style>
